/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * NavigationApi class.
 */
export default class NavigationApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
    }

    /**
     * Get Sensors and Connectors navigation data
     * @returns {promise}
     */
    getSensorsAndConnectors() {
        return this.$http.get(this.config.sensorsAndConnectorsUrl).then(responseDataExtractor);
    }

    /**
     * Update Sensors and Connectors navigation data
     * @param {Array<Object>} objects - Objects to be saved as Sensors and Connectors navigation data
     * @returns {promise}
     */
    updateSensorsAndConnectors(objects) {
        return this.$http.put(this.config.sensorsAndConnectorsUrl, { objects }).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/navigation/navigation.service.js